import { useUser } from "../useUser";

export const useIsInternalAccount = (): boolean => {
  const { allstarUser } = useUser();
  const email = allstarUser?.decoded?.sub;
  const userGroupType = allstarUser?.user?.userGroup?.type;

  return Boolean(
    email?.endsWith("@allstar.gg") || userGroupType === "INTERNAL",
  );
};
